import { jsx as _jsx } from "react/jsx-runtime";
import { FooterContainer } from './Footer.style';
const Footer = ({ children }) => {
    const handleClick = (event) => {
        event.stopPropagation();
    };
    return (_jsx(FooterContainer, { onClick: handleClick, children: children }));
};
export default Footer;
